var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
  'd-none': _vm.hidden,
  tapped: _vm.Tapped,
  flipped: _vm.flipped,
}},[_c('div',{staticClass:"card"})])
}
var staticRenderFns = []

export { render, staticRenderFns }